import { render, staticRenderFns } from "./addedit-consequence.vue?vue&type=template&id=288e1c17"
import script from "./addedit-consequence.vue?vue&type=script&lang=js"
export * from "./addedit-consequence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports